import Image from 'next/image';
import QuizStars from './QuizStars';
import { getImagePath } from '@/utils/images';

const QuizResult = ({ result, congratulationTitle, congratulationSubtitle, scoreLabel }) => {
  const { score, total, resultLevel } = result;

  return (
    <div className="flex min-h-[500px] flex-col items-center">
      <div className="flex flex-1 flex-col items-center justify-center">
        {congratulationTitle && (
          <div className="text-brand-400 mb-1 text-[20px] leading-normal font-medium">{congratulationTitle}</div>
        )}
        {congratulationSubtitle && (
          <div className="mb-8 text-center text-[14px] leading-[23px] font-medium text-white">
            {congratulationSubtitle}
          </div>
        )}

        {scoreLabel && <div className="mb-2 text-[14px] leading-[23px] font-medium text-white">{scoreLabel}</div>}

        <div className="text-brand-400 mb-4 text-[36px] leading-[36px] font-semibold tracking-[-1.08px] uppercase">
          {score}/{total}
        </div>

        <div className="mb-8">
          <QuizStars score={score} total={total} />
        </div>

        {resultLevel && (
          <div className="flex flex-col items-center">
            {resultLevel.image && (
              <div className="relative mb-4">
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="size-[153px] rounded-full bg-white/15 blur-[30px]" />
                </div>
                <div className="relative flex size-[128px] items-center justify-center rounded-full p-4">
                  <Image
                    src={getImagePath(resultLevel.image)}
                    width={resultLevel.image.width || 128}
                    height={resultLevel.image.height || 128}
                    alt={resultLevel.image.alternativeText || resultLevel.title}
                    className="h-[128px] w-[128px] object-contain"
                  />
                </div>
              </div>
            )}
            <div className="text-brand-400 mb-1 text-[20px] leading-normal font-medium">{resultLevel.title}</div>
            {resultLevel.description && (
              <div className="text-center text-[14px] leading-[23px] font-medium text-white">
                {resultLevel.description}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default QuizResult;
